import { useControlPresentation } from "./Internal/useControlPresentation";

/** CSS-ready text metrics, for handing to a control that isn't styled by us. */
interface ControlValueTextStyle {
  fontSize: string;
  lineHeight: string;
  fontWeight: string;
}

export type { ControlValueTextStyle };

/**
 * The value text of an input in the active presentation, as CSS strings rather
 * than classes — for a control ui-core can't reach with a class name because it
 * styles its own text inside a cross-origin iframe (a Stripe card field). The
 * caller hands these straight to that control so its value matches the ui-core
 * inputs beside it.
 *
 * Mirrors `inputBaseStyle` (underlined: text-xl / leading-7 / font-bold) and
 * `boxedBase` (boxed: text-sm / font-medium). Keep the two in step.
 */
export function useControlValueTextStyle(): ControlValueTextStyle {
  return useControlPresentation() === "underlined"
    ? { fontSize: "20px", lineHeight: "28px", fontWeight: "700" }
    : { fontSize: "14px", lineHeight: "20px", fontWeight: "500" };
}
